export interface PropertyFilter {
  propertyId: number | null;
  companyId: number | null;
  propertyTypeId: number | null;
  serviceKey?: string | null;
}
